import styled from 'styled-components'

export const Th = styled.th(({ theme }) => ({
  color: theme.colors.base_100,
  textAlign: 'left',
  padding: theme.space(4),
}))
